import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SortableContainer,
  SortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import _ from "lodash";
import arrayMove from "array-move";
import { fetchEventGuideList, updateEventGuideList } from "ActionsEventguide";
import { showError, showSuccess } from "ReduxErrorBar";
import EventGuideItem from "./eventguide-list-item";
import LocaleStrings from "Languages";
import { Col, Container, Row } from "react-bootstrap";

// userd for sort content list
const DragHandle = sortableHandle(({ docname }) => (
  <div className="col-md-12 DraggedStuff" style={{ paddingLeft: 4 }}>
    <div className="vcenter ">
      <i className="fa fa-bars mx-6" aria-hidden="true"></i>
      <span className="">{docname}</span>
    </div>
  </div>
));

const SortableItem = SortableElement(
  ({ value, pageDataLength, currentPage, finishOperationsCallback }) => (
    <div>
      <EventGuideItem
        mydata={<DragHandle docname={value.title} />}
        key={value.id}
        eventguide={value}
        pageDataLength={pageDataLength}
        currentPage={currentPage}
        finishOperationsCallback={finishOperationsCallback}
      />
    </div>
  )
);

const SortableList = SortableContainer(
  ({
    items,
    pageDataLength,
    currentPage,
    displaycategoryorder,
    finishOperationsCallback,
  }) => {
    return (
      <div>
        {items.map((value, index) => {
          return (
            <SortableItem
              key={`item-${index}`}
              index={index}
              value={value}
              pageDataLength={pageDataLength}
              currentPage={currentPage}
              displaycategoryorder={displaycategoryorder}
              finishOperationsCallback={finishOperationsCallback}
              style={{ zIndex: 100000 }}
            />
          );
        })}
      </div>
    );
  }
);

class EventGuideCategoryItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  // When Component Mount
  componentDidMount() {
    this.setState({ loading: false });

    // Call For Event Guide List
    this.props.fetchEventGuideList(this.props.session, () => {});
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    //var arrAvailable = this.props.eventGuideList.data;
    var arrAvailable = _.filter(this.props.eventGuideList.data, {
      displaycategoryorder: this.props.category.displaycategoryorder,
    });

    arrAvailable = arrayMove(arrAvailable, oldIndex, newIndex);

    var newArrAvailable = [];

    this.setState({ activeCount: arrAvailable.length });

    arrAvailable.map((value, index) => {
      newArrAvailable.push({ ...value, displayorder: index + 1 });
    });

    this.setState({ pageLoader: true });
    this.props.updateEventGuideList(
      this.props.session,
      newArrAvailable,
      (res) => {
        if (res.success) {
          this.setState({ pageLoader: false });
        } else {
          // console.log("Error.");
        }

        // Call For Event Guide List
      }
    );
  };

  finishOperationsCallback = () => {
    this.props.finishOperationsCallback();
  };

  render() {
    let { category, eventGuideList } = this.props;
    let { pageNumber, pageLoader } = this.state;
    let eventguideList = eventGuideList.data;
    eventguideList = _.filter(eventguideList, {
      displaycategoryorder: category.displaycategoryorder,
    });
    let pageDataLength =
      eventGuideList && eventGuideList.data ? eventGuideList.data.length : 0;

    var classCustom = "";
    if (pageLoader) {
      classCustom = "gamification-page-loading";
    }

    return (
      <Container
        fluid
        style={{
          fontWeight: "normal",
          color: "rgb(63,68,88)",
          // borderTop: "1px solid #e6edf3",
          padding: "10px 0",
          cursor: "move",
          marginLeft: "15px",
        }}
      >
        {/* Puting Table inside */}
        <Row
          className="row mb-12"
          style={{ fontWeight: 700, color: "rgb(195,203,223)" }}
        >
          <Col className="eventguide-thead pr-0" style={{ paddingLeft: 88 }}>
            <div style={{ paddingLeft: 27 }}>
              {LocaleStrings.eventguide_list_text_title}
            </div>
          </Col>
          <Col className="p-0">{LocaleStrings.eventguide_list_text_type}</Col>
          <Col className="p-0">{LocaleStrings.eventguide_list_text_action}</Col>
        </Row>
        {eventguideList && eventguideList.length > 0 ? (
          <div
            className={`col-md-11 ${classCustom}`}
            style={{
              backgroundColor: "#ffffff",
              backfaceVisibility: "hidden",
              willChange: "transform",
              userSelect: "none",
              WebkitUserSelect: "none",
              titleBarStyle: "hidden",
              marginLeft: "15px",
            }}
          >
            <SortableList
              useDragHandle
              items={eventguideList}
              onSortEnd={this.onSortEnd}
              //pressDelay={200}
              axis="y"
              lockAxis="y"
              pageDataLength={pageDataLength}
              currentPage={pageNumber}
              displaycategoryorder={category.displaycategoryorder}
              finishOperationsCallback={this.finishOperationsCallback}
            />
          </div>
        ) : (
          ""
        )}
      </Container>
    );
  }
}

export var mapStateToProps = (state) => {
  var { session } = state;
  return {
    session: state.session,
    eventGuideList: state.eventGuideList,
  };
};

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchEventGuideList,
  updateEventGuideList,
})(EventGuideCategoryItem);
